module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/pins/gold-cbc68cabab76c9a3b8da4d833e6d045a.svg";